import { render, staticRenderFns } from "./RegistrationFormViewPage.vue?vue&type=template&id=6bfe22df&scoped=true&"
import script from "./RegistrationFormViewPage.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormViewPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormViewPage.vue?vue&type=style&index=0&id=6bfe22df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe22df",
  null
  
)

export default component.exports